import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=7a281501&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"
import style0 from "./orderView.vue?vue&type=style&index=0&id=7a281501&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a281501",
  null
  
)

export default component.exports